import {
  FETCH_TUTOR_ISSUE_RATE_SENT,
  FETCH_TUTOR_ISSUE_RATE_SUCCEEDED,
  FETCH_TUTOR_ISSUE_RATE_FAILED,
} from '../../actions/tutorData';

const initialState = {
  loading: false,
  loaded: false,
  issueRate: 0,
  numOfLessons: 0,
};

export default function tutorIssueRateReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_TUTOR_ISSUE_RATE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        loaded: true,
        issueRate: payload.issue_rate,
        numOfLessons: payload.num_of_lessons,
      };
    case FETCH_TUTOR_ISSUE_RATE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FETCH_TUTOR_ISSUE_RATE_SENT:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
